<template>
  <transition name="fade" :key="keyModal">
    <div class="modal" v-if="value" style="display: block" @click.self.prevent="closeZoomPhoto">
      <div class="modal-dialog modal-big-dialog">
        <div class="modal-content modal-big-content">
          <img class="photo-img big-photo" :src="photo" @click="closeZoomPhoto" alt=""/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ZoomPhoto',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    photo: {
      type: String,
      default: '',
    },
    keyModal: {
      type: String,
    },
  },
  data: () => ({}),
  methods: {
    closeZoomPhoto () {
      this.$emit('closeZoomPhoto');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-dialog {
  max-width: 100%;
  margin: auto;

  .modal-content.modal-big-content {
    max-width: 100%;
    background: transparent;

    .photo-img.big-photo {
      cursor: pointer;
      width: 100%;
      margin-bottom: -3px;
    }
  }
}
</style>
